<template>
  <v-btn-toggle :value="value ? 'compact' : 'extended'" mandatory @change="onChange">
    <v-btn value="compact" title="Vista compacta">
      <v-icon left>mdi-arrow-collapse-horizontal</v-icon>
      {{ $t('Compacta') }}
    </v-btn>
    <v-btn value="extended" title="Vista extensa">
      <v-icon left>mdi-arrow-expand-horizontal</v-icon>
      {{ $t('Extensa') }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
/**
 * Selector de estilo de las rejillas de control: vista compacta (clase `og-compact-table`,
 * estados abreviados) o extensa. Solo cambia la presentación. `v-model` es true en compacta.
 */
export default {
  name: 'OgTableViewToggle',
  props: {
    value: { type: Boolean, default: true },
  },
  methods: {
    onChange(view) {
      this.$emit('input', view === 'compact');
    },
  },
};
</script>
